import { Component, OnInit } from '@angular/core';
import {
  Router,
  Event,
  NavigationEnd,
} from '@angular/router';
import { Location } from '@angular/common';
import { NavigationModel } from '@models/navigation.model';
import { AuthService } from '@services/auth/auth.service';
import { isPermissionExist } from '@helpers/permissions';
import { RocheDoctorPermission } from 'src/app/_constants/permissions';
import { take } from 'rxjs/operators';
import * as Sentry from "@sentry/angular";
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false
})
export class NavbarComponent implements OnInit {
  userName = localStorage.getItem('fullName');
  sidenavOpen: boolean = true;
  location: Location;
  navigationModel: NavigationModel;

  constructor(
    location: Location,
    private router: Router,
    private authService: AuthService
  ) {
    this.navigationModel = new NavigationModel();
    this.location = location;

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (window.innerWidth < 1200) {
          document.body.classList.remove('g-sidenav-pinned');
          document.body.classList.add('g-sidenav-hidden');
          this.sidenavOpen = false;
        }
      }
    });
  }

  ngOnInit() {
  }

  onLogOut() {
    Sentry.setUser(null); // Reset sentry user data
    this.authService
      .logout()
      .pipe(take(1))
      .subscribe(() => {
        const loginPath = isPermissionExist(RocheDoctorPermission) ? 'auth/login/phone' : 'auth/login/email';
        localStorage.clear();
        this.router.navigateByUrl(loginPath);
      });
  }

  openSidebar() {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
      this.sidenavOpen = false;
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
      this.sidenavOpen = true;
    }
  }

  toggleSidenav() {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
      this.sidenavOpen = false;
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
      this.sidenavOpen = true;
    }
  }
}
